/**
 * Entity hub API — GET /api/entities/:entityId/hub
 * Contract: frontend handoff (matchKind / Entity Hub) + ENTITY_HUB_BACKEND_HANDOFF.md
 */

import { BACKEND_URL } from './config';
import { isHubMockEnabled, getMockHub } from '../fixtures/entityHubMocks';

/**
 * @param {string} entityId
 * @returns {Promise<object|null>} Hub payload or null on error / missing
 */
export async function fetchEntityHub(entityId) {
  if (!entityId) return null;

  if (isHubMockEnabled()) {
    return getMockHub(entityId);
  }

  try {
    const response = await fetch(
      `${BACKEND_URL}/api/entities/${encodeURIComponent(entityId)}/hub`,
      {
        method: 'GET',
        headers: { Accept: 'application/json' },
      }
    );

    if (response.status === 404) return null;
    if (!response.ok) return null;

    return await response.json();
  } catch {
    return null;
  }
}
